/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:39
 * @LastEditors: bbq
 * @LastEditTime: 2020-12-14 15:09:08
 */
import React, { Component } from 'react';
import WithKeyboardChange from '../WithKeyboardChange';
import Tooltip from '../Tooltip';
import { getMultiLang } from '@platform/api';

const { BackBtnWithKeyboardChange } = WithKeyboardChange;

require('./index.less');

@BackBtnWithKeyboardChange
class NCBackBtn extends Component {
    constructor(props) {
        super(props);
        this.state = { langJson: {} };
    }

    UNSAFE_componentWillMount() {
        let callback = langJson => {
            this.setState({ langJson });
        };
        // moduleId为所需加载langJson文件夹名称前缀
        getMultiLang({ moduleId: 'common_icon_title', callback });
    }

    render() {
        let { langJson } = this.state;
        let { onClick, className = '', tooltip = langJson['icon-back'], ...others } = this.props;
        return (
            <Tooltip
                placement="top"
                overlay={tooltip}
                delayHide={1}
                delayShow={1000}
            >
                <span
                    className={`${className} back-btn iconfont icon icon-danjufanhuiicon`}
                    onClick={() => {
                        if (onClick && typeof onClick === 'function') {
                            onClick();
                        }
                    }}
                    {...others}
                />
            </Tooltip>
        );
    }
}

export default NCBackBtn;
